<template>
  <div class="container form-container">
    <fieldset>
      <legend>{{ title }}</legend>

      <form>
        <slot name="fields">
          <p>fields should go here</p>
        </slot>
        <slot name="buttons">
        
        </slot>
      </form>
    </fieldset>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  title: { type: String, required: true }
})
</script>

<style scoped lang="css">
form {
  display: flex;
  flex-flow: column wrap;
  /* flex-direction: column;*/
  align-items: stretch;
}
</style>
